export default __webpack_public_path__ + "static/media/flower1.d26e7b4a.svg";